import Website from './models/Website'
import User from './models/User'
import Domain from './models/Domain'
import Stripe from './models/Stripe'
import Brand from './models/Brand'
import Listing from './models/Listing'
import _ from 'lodash'
import async from 'async'
import { scroller } from 'react-scroll'
import { v1 } from 'node-uuid'

const controller = {
  getUser(_this) {
    if (!_this.props.location)
      return
    const params = {
      access_token: _this.props.location.query.access_token
    }
    User.get(params, (err, res) => {
      if (!err && res) {
        const user = res && res.data ? res.data : undefined;
        const website = {
          ..._this.state.data.website,
          user,
          brand: res.data.brand
        }
        _this.setState({
          data: {
            ..._this.state.data,
            website,
            is_editable: true,
            user
          }
        })
        if (_this.state && _this.state.data && !_this.state.data.brand && user.brand)
          this.getBrand(_this, user.brand)
        let agent_id
        if (user.agent) {
          agent_id = user.agent.mls_id
          controller.getListings(_this, agent_id)
        }
      }
    })
  },
  getListings(_this, agent) {
    const options = {
      limit: '75',
      maximum_lot_square_meters: 100000000,
      minimum_bathrooms: 0,
      horizontal_distance: 2830,
      property_types: ['Residential', 'Residential Lease', 'Lots & Acreage'],
      vertical_distance: 2830,
      minimum_square_meters: 0,
      listing_statuses: ['Active', 'Active Contingent', 'Active Kick Out', 'Active Option Contract', 'Pending'],
      minimum_lot_square_meters: 0,
      currency: 'USD',
      points: null,
      minimum_bedrooms: 0,
      minimum_price: 0,
      open_house: false,
      property_subtypes: ['RES-Single Family', 'RES-Half Duplex', 'RES-Farm/Ranch', 'RES-Condo', 'RES-Townhouse', 'LSE-Apartment', 'LSE-Condo/Townhome', 'LSE-Duplex', 'LSE-Fourplex', 'LSE-House', 'LSE-Mobile', 'LSE-Triplex', 'LND-Commercial', 'LND-Farm/Ranch', 'LND-Residential']
    }
    if (agent)
      options.agents = [agent]
    const params = {
      options,
      access_token: _this.props.location.query.access_token
    }
    Listing.getValerts(params, (err, res) => {
      _this.setState({
        data: {
          ..._this.state.data,
          listings: res.data
        }
      })
    })
  },
  getBrand(_this, id) {
    const params = {
      id
    }
    Brand.get(params, (err, res) => {
      let brand = res.data
      if (brand) {
        if (!res.data.assets)
          brand = res.data.parent
        _this.setState({
          data: {
            ..._this.state.data,
            brand
          }
        })
      }
    })
  },
  selectTemplate(_this, template) {
    const data = _this.state.data
    const params = {
      template
    }
    Website.getTemplate(params, (err, res) => {
      if (!err) {
        let website = {
          ...res,
          user: {},
          brand: null
        }
        if (data.website && data.website.template === data.selected_template)
          website = data.website
        const default_template = require(`./components/Templates/${template}/template.json`)
        const steps = default_template.steps
        steps.forEach(step => {
          const attributes = step.attributes
          attributes.forEach(attribute => {
            attribute.value = default_template.attributes[attribute.key]
          })
        })
        _this.setState({
          data: {
            ..._this.state.data,
            ...default_template,
            website,
            selected_template: template,
            is_editable: true,
            show_layouts_bar: true,
            step: 1
          }
        })
        controller.getUser(_this)
      }
    })
  },
  // initFirstWebsite(_this) {
  //   controller.selectTemplate(_this, 'light')
  //   _this.setState({
  //     data: {
  //       ..._this.state.data,
  //       selected_template: 'light',
  //       show_edit_bar: true,
  //       show_overview: true,
  //       template_width: window.innerWidth - 400
  //     }
  //   })
  // },
  getWebsites(_this, access_token) {
    const params = {
      access_token
    }
    Website.getAll(params, (err, res) => {
      if (!err && res) {
        // // No 
        // if (!res.data || !res.data[0])
        //   return controller.initFirstWebsite(_this)
        _this.setState({
          data: {
            ..._this.state.data,
            websites: res.data,
            template_width: window.innerWidth - 400,
            websites_loaded: true
          }
        })
        // TODO Remove website to expose other websites besides Agent
        // controller.selectWebsite(_this, res.data[0])
      } else {
        console.log('getWebsites error')
      }
    })
  },
  getWebsite(_this, id, access_token) {
    const params = {
      access_token,
      id
    }
    Website.get(params, (err, res) => {
      controller.selectCurrentWebsite(_this, res.data)
    })
  },
  getListing(_this, mls_number) {
    controller.selectNewWebsite(_this, mls_number)
  },
  selectNewWebsite(_this, mls_number) {
    const data = _this.state.data
    let website = data.website
    if (!website)
      website = {}
    if (!website.attributes)
      website.attributes = {}
    if (mls_number)
      website.attributes.mls_number = mls_number
    if (mls_number)
      website.template = 'clean'
    else
      website.template = 'light'
    const default_template = require(`./components/Templates/${website.template}/template.json`)
    website.attributes = default_template.attributes
    const steps = default_template.steps
    const saved_attributes = {
      ...default_template.attributes,
      ...website.attributes
    }
    steps.forEach(step => {
      const attributes = step.attributes
      attributes.forEach(attribute => {
        attribute.value = saved_attributes[attribute.key]
      })
    })
    async.series([
      callback => {
        // Get Listing Info
        if (mls_number) {
          Listing.getByMLS({ mls_number }, (err, res) => {
            website.listing = res.data
            callback()
          })
        } else {
          callback()
        }
      },
      callback => {
        _this.setState({
          data: {
            ..._this.state.data,
            website,
            selected_template: website.template,
            attributes: saved_attributes,
            steps: [
              ...steps
            ],
            step: 1,
            show_edit_bar: true,
            is_editable: true,
            template_width: window.innerWidth - 400
          }
        })
      }
    ])
  },
  selectCurrentWebsite(_this, website) {
    // get brand
    if (website && website.brand)
      website.brand = Brand.flatten(website.brand)

    // Reset input values in steps
    const default_template = require(`./components/Templates/${website.template}/template.json`)
    const steps = default_template.steps
    const saved_attributes = website.attributes
    steps.forEach(step => {
      const attributes = step.attributes
      attributes.forEach(attribute => {
        attribute.value = saved_attributes[attribute.key]
      })
    })
    async.series([
      callback => {
        // Get Listing Info
        if (website.attributes.mls_number) {
          const mls_number = website.attributes.mls_number
          Listing.getByMLS({ mls_number }, (err, res) => {
            website.listing = res.data
            callback()
          })
        } else {
          callback()
        }
      },
      callback => {
        _this.setState({
          data: {
            ..._this.state.data,
            website,
            selected_template: website.template,
            attributes: saved_attributes,
            steps: [
              ...steps
            ],
            step: 1,
            show_edit_bar: true,
            show_overview: true,
            is_editable: true,
            is_existing_website: true,
            template_width: window.innerWidth - 400
          }
        })
      }
    ])
  },
  beginNewWebsite() {
    const data = this.state.data
    delete data.website
    delete data.show_websites
    delete data.is_existing_website
    data.show_layouts_bar = true
    data.template_width = window.innerWidth - 400
    this.setState({
      data
    })
  },
  showOverview() {
    const data = this.state.data
    delete data.show_edit_domains_panel
    this.setState({
      data: {
        ...this.state.data,
        show_overview: true
      }
    })
  },
  goToStep(_this, step) {
    const data = _this.state.data
    if (!data.is_editable)
      return
    delete data.show_overview
    data.step = step
    delete data.show_layouts_bar
    data.show_edit_bar = true
    _this.setState({
      data
    })
    scroller.scrollTo(`step-${_this.state.data.step}`, {
      offset: -100,
      duration: 1500,
      smooth: true
    })
  },
  editText(key, value) {
    const data = this.state.data
    const steps = data.steps
    const step = steps[data.step - 1]
    const attribute = _.find(step.attributes, { key })
    attribute.value = value
    data.attributes[key] = value
    data.website.attributes[key] = value
    this.setState({
      data: {
        ...this.state.data
      }
    })
    window.onbeforeunload = () => {
      return confirm("Are you sure you want to leave?  Any unsaved changes will be lost.")
    }
  },
  uploadMedia(key, accepted_files) {
    const data = this.state.data
    const steps = data.steps
    const step = steps[data.step - 1]
    const attribute = _.find(step.attributes, { key })
    const file = accepted_files[0]
    attribute.file = file
    attribute.value = file.preview
    data.attributes[key] = accepted_files[0].preview
    this.setState({
      data: {
        ...this.state.data
      }
    })
  },
  getFiles(_this) {
    const data = _this.state.data
    const steps = data.steps
    const attributes = _.flatMap(steps, 'attributes')
    const file_attributes = _.filter(attributes, attribute => { return attribute.type === 'Media' })
    if (file_attributes && file_attributes.length)
      return file_attributes
  },
  saveWebsite(is_preview) {
    window.onbeforeunload = null
    const data = this.state.data
    const attributes = {
      ...data.attributes,
      ...data.website.attributes
    }
    if (data.website.listing)
      attributes.mls_number = data.website.listing.mls_number
    const params = {
      website: {
        template: data.selected_template,
        brand: data.website ? data.website.brand : null,
        attributes
      },
      access_token: this.props.location.query.access_token
    }
    if (is_preview)
      data.preview_loading = true
    this.setState({
      data: {
        ...data,
        saving_website: true
      }
    })
    // Test if files uploaded
    const file_attributes = controller.getFiles(this)
		if (file_attributes) {
			if (!this.state.data.website.id)
				controller.createOrEditWebsite(this, params, is_preview, (website) =>
					controller.saveWithFiles(this, params, file_attributes, is_preview, website)
				)
			else
				controller.saveWithFiles(this, params, file_attributes, is_preview)
			return
		}
    controller.createOrEditWebsite(this, params, is_preview)
  },
  saveWithFiles(_this, params, file_attributes, is_preview, website) {
    async.eachSeries(file_attributes, (file_attribute, callback) => {
      if (!file_attribute.file)
        return callback()
      const upload_params = {
        file: file_attribute.file,
        access_token: _this.props.location.query.access_token,
        websiteId: _this.state.data.website.id || website.id
      }
      Website.uploadFiles(upload_params, (err, res) => {
        params.website.attributes[file_attribute.key] = res.data.url
        callback()
      })
    }, () => {
      controller.createOrEditWebsite(_this, params, is_preview)
    })
  },
  createOrEditWebsite(_this, params, is_preview, callBack) {
    const existing_website = _this.state.data.website
    if (!params.website.brand)
        delete params.website.brand
    if (existing_website && existing_website.id) {
      // Edit website
      params.id = existing_website.id
      if (params.website.brand)
        params.website.brand = params.website.brand.id
      Website.edit(params, (err, res) => {
        delete _this.state.data.saving_website
        if (err) {
          _this.setState({
            data: {
              ..._this.state.data,
              website_save_error: true,
              show_overview: true
            }
          })
          return
        }
        // Create hostnames
        if (_this.state.data.added_domain_fields) {
          const added_hostnames = _.map(_this.state.data.added_domain_fields, 'value')
          let hostname_params
          async.eachSeries(added_hostnames, (hostname, domainCallback) => {
            hostname_params = {
              id: existing_website.id,
              hostname,
              is_default: false,
              access_token: _this.props.location.query.access_token
            }
            Website.createHostname(hostname_params, (err, res) => {
              domainCallback()
            })
          })
        }
        if (is_preview) {
          _this.setState({
            data: {
              ..._this.state.data,
              preview_ready: true,
              preview_url: 'http://' + res.data.hostnames[0]
            }
          })
          return
        }
        // Show modal
        _this.setState({
          data: {
            ..._this.state.data,
            show_website_saved_modal: true,
            show_overview: true
          }
        })
        // Hide modal
        setTimeout(() => {
          delete _this.state.data.show_website_saved_modal
          _this.setState({
            data: {
              ..._this.state.data
            }
          })
        }, 3000)
      })
    } else {
      // Create website
      Website.create(params, (err, res) => {
        delete _this.state.data.saving_website
        if (err) {
          _this.setState({
            data: {
              ..._this.state.data,
              website_save_error: true,
              show_overview: true
            }
          })
          return
        }
        callBack(res.data);
        if (is_preview) {
          _this.setState({
            data: {
              ..._this.state.data,
              preview_ready: true,
              preview_url: 'http://' + res.data.hostnames[0],
              website: res.data
            }
          })
        } else {
          window.location.href = `/?access_token=${_this.props.location.query.access_token}&website=${res.data.id}&edit=domains`
        }
      })
    }
  },
  resetPreview() {
    const data = this.state.data
    window.location.href = `/?access_token=${this.props.location.query.access_token}&website=${data.website.id}`
  },
  closeModal() {
    const data = this.state.data
    delete data.show_domain_modal
    delete data.show_checkout_modal
    delete data.show_payment_success
    delete data.show_card_form
    delete data.show_agreement_modal
    delete data.show_remove_card_confirm_modal
    delete data.show_website_saved_modal
    delete data.show_card_updated_success
    delete data.show_payment_success_modal
    this.setState({
      data
    })
  },
  closeAgreementModal() {
    const data = this.state.data
    delete data.show_agreement_modal
    delete data.getting_agreement
    this.setState({
      data
    })
  },
  closeRemoveCardConfirmModal() {
    const data = this.state.data
    delete data.show_remove_card_confirm_modal
    this.setState({
      data
    })
  },
  getDomainSuggestions(_this, q) {
    const data = _this.state.data
    data.is_getting_domains = true
    _this.setState({
      data
    })
    const params = {
      q,
      access_token: _this.props.location.query.access_token
    }
    Domain.suggest(params, (err, res) => {
      delete data.is_getting_domains
      data.domain_suggestions = res.data
      _this.setState({
        data
      })
    })
  },
  submitPayment(params, callback) {
    Stripe.createCustomer(params, (err, res) => {
      callback(err, res)
    })
  },
  deleteCustomer(params, callback) {
    Stripe.deleteCustomer(params, (err, res) => {
      callback(err, res)
    })
  },
  getCustomer(params, callback) {
    Stripe.getCustomer(params, (err, res) => {
      callback(err, res)
    })
  },
  purchaseDomain(params, callback) {
    Domain.purchase(params, (err, res) => {
      callback(err, res)
    })
  },
  getDomainAgreement(params, callback) {
    Domain.getAgreement(params, (err, res) => {
      callback(err, res)
    })
  },
  showAgentTemplates() {
    const data = this.state.data
    delete data.show_agent_templates
    data.show_agent_templates = true
    this.setState({
      data
    })
  },
  showListingTemplates() {
    const data = this.state.data
    delete data.show_agent_templates
    data.show_listing_templates = true
    this.setState({
      data
    })
  },
  selectProduct(product) {
    const data = this.state.data
    delete data.show_agent_templates
    delete data.show_listing_templates
    if (product === 'agent_websites') {
      data.selected_template = 'light'
      data.show_agent_templates = true
    }
    if (product === 'listing_websites') {
      data.selected_template = 'clean'
      data.show_listing_templates = true
    }
    this.setState({
      data
    })
  },
  seachListings(q) {
    const data = this.state.data
    data.mls_input_value = q
    this.setState({
      data
    })
    if (q.length < 5)
      return
    const params = {
      q
    }
    Listing.search(params, (err, res) => {
      data.listings = res.data
      this.setState({
        data
      })
    })
  },
  selectListing(listing) {
    const data = this.state.data
    data.selected_listing = listing
    delete data.listings
    data.website.attributes.mls_number = listing.mls_number
    data.attributes.mls_number = listing.mls_number
    Listing.getByMLS({ mls_number: listing.mls_number }, (err, res) => {
      data.website.listing = res.data
      data.mls_input_value = res.data.mls_number
      if (data.steps[0] && data.steps[0].attributes)
        data.steps[0].attributes[0].value = data.mls_input_value
      this.setState({
        data
      })
    })
  },
  removeSearchListings() {
    const data = this.state.data
    delete data.listings
    this.setState({
      data
    })
  },
  showEditDomainsPanel() {
    const data = this.state.data
    delete data.show_overview
    data.show_edit_domains_panel = true
    this.setState({
      data
    })
  },
  addDomainField() {
    const data = this.state.data
    if (!data.added_domain_fields)
      data.added_domain_fields = []
    data.added_domain_fields.push({
      id: v1(),
      value: ''
    })
    this.setState({
      data
    })
  },
  removeDomainField(id) {
    const data = this.state.data
    data.added_domain_fields = data.added_domain_fields.filter(field => {
      return field.id !== id
    })
    this.setState({
      data
    })
  },
  addDomainValue(id, e) {
    const data = this.state.data
    const index = _.findIndex(data.added_domain_fields, { id })
    data.added_domain_fields[index].value = e.target.value
    this.setState({
      data
    })
  },
  deleteDomain(hostname) {
    const data = this.state.data
    const website = data.website
    const params = {
      id: website.id,
      hostname,
      access_token: this.props.location.query.access_token
    }
    Website.deleteHostname(params, (err, response) => {
      data.website.hostnames = _.filter(data.website.hostnames, hostname_in_loop => hostname_in_loop !== hostname)
      this.setState({
        data
      })
    })
  },
  addGalleryImage(key, image_url) {
    const data = this.state.data
    data.website.attributes[key] = image_url
    data.website.attributes[key] = image_url
    this.setState({
      data
    })
  },
  showModalGallery() {
    const data = this.state.data
    data.show_modal_gallery = true
    this.setState({
      data
    })
  },
  hideModalGallery() {
    const data = this.state.data
    delete data.show_modal_gallery
    this.setState({
      data
    })
  },
  showListingMap() {
    const data = this.state.data
    data.show_listing_map = true
    this.setState({
      data
    })
  },
  hideListingMap(name) {
    const data = this.state.data
    delete data.show_listing_map
    this.setState({
      data
    })
    const element = this[name]
    var bodyRect = document.body.getBoundingClientRect()
    const elemRect = element.getBoundingClientRect()
    const offset   = elemRect.top - bodyRect.top
    window.scrollTo(0, offset)
  },
  removeAttr(attr) {
    const data = this.state.data
    delete data.website.attributes[attr.key]
    data.steps.forEach(step => {
      step.attributes.forEach(attr_loop => {
        if (attr_loop.key === attr.key)
          attr_loop.value = null
      })
    })
    this.setState({
      data
    })
  }
}
export default controller


// WEBPACK FOOTER //
// ./src/controller.js